import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Toaster } from 'react-hot-toast';
import './i18n/config'; // Initialize i18n
import { LanguageProvider } from './i18n/LanguageProvider';
import App from './App';
import './index.css';
import { brandTokens, theme } from './theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
            <LanguageProvider>
              <App />
              <Toaster
                position="top-center"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: brandTokens.white,
                    color: brandTokens.textPrimary,
                    border: '1px solid rgba(10, 15, 28, 0.08)',
                    borderRadius: '16px',
                    boxShadow: '0 18px 40px rgba(15, 23, 42, 0.12)',
                    padding: '14px 16px',
                  },
                  success: {
                    iconTheme: {
                      primary: brandTokens.successGreen,
                      secondary: brandTokens.white,
                    },
                  },
                  error: {
                    iconTheme: {
                      primary: brandTokens.errorRed,
                      secondary: brandTokens.white,
                    },
                  },
                }}
              />
            </LanguageProvider>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
